// files
import AdminUsers from "../../Components/Admin/AdminUsers"
const AdminUsersPage = () => {
  return (
    <AdminUsers />
  )
}
export default AdminUsersPage